jQuery_T4NT(document).ready(function($) {
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

        /*if( jQuery('.t4s-products').find('.t4s-product').length > 0 ){
          jQuery('.t4s-products').find('.t4s-product').each(function(){
             if(jQuery(this).find('.wc-meta-color-swatches').first().hasClass('active')){
                var color_product_image = jQuery(this).find('.wc-meta-color-swatches').first().attr('color_product_image');
                console.log(color_product_image);
                jQuery(this).find('.t4s-product-main-img').attr('src',color_product_image);
                jQuery(this).find('.t4s-product-main-img').attr('srcset',color_product_image);
             } 
          });
        }*/
 $( document ).on( "variant:changed", function( evt ) {
     if( jQuery('.template-product .t4s-swatch__item').length > 0 ){
          if( evt.currentVariant.id !== undefined ){            
              setTimeout(function () {                
                              jQuery('.custom-notify-btn' ).attr( 'data-variant-id',  evt.currentVariant.id );
              },1000);
          }
     }	   	     
	   });
     $( document ).on( "variant:changed", function( evt ) {
  if( evt.currentVariant && evt.currentVariant.id !== undefined ) {
    if( typeof sizeConversion === 'function' ) {
      sizeConversion( evt.currentVariant.id );
    }
  }
});

  jQuery(document).on('click','.template-product .t4s-swatch__item',function(){
        jQuery(this).parents('.t4s-form__product').find('.custom-notify-btn').remove();
        jQuery(this).parents('.t4s-form__product').find('.t4s-product-form__submit').show();
        jQuery(this).parents('.t4s-form__product').find('button[disabled="disabled"]').hide();

        if(jQuery(this).hasClass('is--soldout')){
          jQuery('.t4s-swatch__item').removeClass('is--selected');
          jQuery(this).parents('.t4s-form__product').find('.out-of-stock').remove();
           jQuery(this).addClass('is--selected');
           jQuery(this).parents('.t4s-form__product').find('.t4s-product-form__qty').hide();
           jQuery(this).parents('.t4s-form__product').find('.t4s-product-form__submit').hide();
           jQuery(this).parents('.t4s-form__product').find('.out-of-stock').remove();
           jQuery(this).parents('.t4s-form__product').find('.t4s-product-form__buttons').after('<button id="BIS_trigger" class="custom-notify-btn" type="button" class="btn" style="margin-top: 10px;">NOTIFY ME WHEN BACK IN STOCK</button>');
           jQuery(this).parents('.t4s-form__product').find('.t4s-pr-wishlist').before('<button data-animation-atc="{ &quot;ani&quot;:&quot;t4s-ani-shake&quot;,&quot;time&quot;:6000 }" type="submit" name="add" data-atc-form="" class="t4s-product-form__submit t4s-btn t4s-btn-base t4s-btn-style-default t4s-btn-color-primary t4s-w-100 t4s-justify-content-center t4s-btn-effect-sweep-to-top t4s-btn-loading__svg" aria-disabled="true" disabled="disabled"><span class="t4s-btn-atc_text">Out of stock</span><span class="t4s-loading__spinner" hidden=""><svg width="16" height="16" hidden="" class="t4s-svg-spinner" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="t4s-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></span></button>');
           jQuery(this).parents('.t4s-form__product').find('.t4s-pr__notify-stock').show();
            setTimeout(function() {
              jQuery('#BIS_trigger').css('display','block !important');
            }, 2500);
        }
      });


        if(jQuery('.wc-custom-color-swatches').find('.wc-meta-color-swatches').first().hasClass('active')){
          var color_product_image = jQuery('.wc-custom-color-swatches').find('.wc-meta-color-swatches').first().attr('color_product_image');
          console.log(color_product_image);
        }

        jQuery(document).on('click','.wc-meta-color-swatches',function(){
          jQuery(this).parents('.t4s-product').find('.wc-meta-color-swatches').removeClass('active');
          jQuery(this).addClass('active');
          var image_url= jQuery(this).attr('color_product_image');
          var newImageUrl= jQuery(this).attr('hover-image');
          var product_url = jQuery(this).attr('product_url');

           jQuery(this).parents('.t4s-product').find('.t4s-product-main-img').attr('srcset',image_url);
           jQuery(this).parents('.t4s-product').find('.t4s-product-hover-img').attr('srcset', newImageUrl);
           jQuery(this).parents('.t4s-product').find('.t4s-full-width-link').attr('href', product_url);
       });

setTimeout(() => {
   // jQuery('.template-index').find('.fs-timeline').slick({
   //    dots: false,
   //    infinite: false,
   //    speed: 300,
   //    slidesToShow: 4,
   //    slidesToScroll: 4,
   //    responsive: [
   //      {
   //        breakpoint: 1024,
   //        settings: {
   //          slidesToShow: 3,
   //          slidesToScroll: 3
   //        }
   //      },
   //      {
   //        breakpoint: 600,
   //        settings: {
   //          slidesToShow: 2,
   //          slidesToScroll: 2
   //        }
   //      },
   //      {
   //        breakpoint: 480,
   //        settings: {
   //          slidesToShow: 1,
   //          slidesToScroll: 1
   //        }
   //      }
   //    ]
   //  });
}, 5000);


        if( jQuery('.t4s-navigation ul li').length > 0 ){

              var path = jQuery(location).prop('pathname');
            setTimeout(function() { 
                  jQuery('.t4s-navigation .t4s-nav__ul li').each(function(){

                     var current_li = jQuery(this);
                     var href = current_li.find('a').attr('href');
                     if( path == href ){
                        current_li.addClass("sk_active").parents('.t4s-type__mega').addClass("sk_active_mega");
                    }
                  });

                jQuery('.t4s-navigation .t4s-nav__ul li .type_mn_link').each(function(){

                     var type_link = jQuery(this);
                     var href = type_link.find('a').attr('href');
                     if( path == href ){
                        type_link.addClass("sk_active").parents('.t4s-type__mega').addClass("sk_active_mega");
                    }
                });
            },1000);
        }

     jQuery(document).on("click","#ssw-avg-rate-profile-html .ssw-stars.ssw-stars-large",function(){
        jQuery('.shopify-app-block .ssw-review-widget-lazyload').addClass('active');
     });

     jQuery(document).on('click','.t4s-btn-filter',function(){
        make_filter_block_active();
     });

     function handleClickOutside(e) {
          if (jQuery(".wc-custom-filter-box").length > 0 && jQuery('body').hasClass('wc-filter-active')) {
              var s_container = jQuery(".wc-custom-filter-box");                  
              // if the target of the click/touch isn't the container nor a descendant of the container
              if (!s_container.is(e.target) && s_container.has(e.target).length === 0) {
                 jQuery('.wc-custom-filter-box').removeClass("sk-aria-hidden");
                 jQuery('.t4s-close-overlay').removeClass('is--visible');
                 jQuery('body').removeClass('wc-filter-active');              
              }
          }
      }
      jQuery(document).on('mouseup touchstart', handleClickOutside);

      jQuery(document).on( 'click', '.t4s-collection-header button.t4s-btn-filter', function () {
          setTimeout(function () {
            jQuery('body').addClass('wc-filter-active');
          },10);
      } );

      jQuery(document).on("click",".t4s-filter__values li",function(){
         var parent_block = jQuery(this).parents('.t4s-facet');
         //jQuery('.wc-custom-filter-box').addClass("sk-aria-hidden");
        //jQuery(this).parents('.t4s-filter-hidden').addClass("sk-aria-hidden");
        // jQuery('.t4s-close-overlay').addClass('is--visible');
         setTimeout(function(){
             make_filter_block_active();
             hide_out_of_stock_when_filter_active();
         },2000);
      });
   
     jQuery(document).on("click",".t4s-drawer__close",function(){
         //jQuery(this).parents('.is--t4s-filter-native').removeClass("sk-aria-hidden");
       jQuery('.wc-custom-filter-box').removeClass("sk-aria-hidden");
        // jQuery(this).parents('.t4s-filter-hidden').removeClass("sk-aria-hidden");
         jQuery('.t4s-close-overlay').removeClass('is--visible');
       jQuery('body').removeClass('wc-filter-active');
      });
      jQuery(document).on("click",".t4s-drawer__main .t4s-facets__form .t4s-col-item",function(){
      // jQuery(".t4s-drawer__main .t4s-facets__form .t4s-col-item").removeClass('active');
          $(this).toggleClass('active');
      });
      hide_out_of_stock_when_filter_active();
});

jQuery(document).on('scroll', function(){
  hide_out_of_stock_when_filter_active();
})

function getQueryParams(url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var queryParts = query.split('&');

    for (var i = 0; i < queryParts.length; i++) {
        var pair = queryParts[i].split('=');
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1] || '');
        if (!params[key]) {
            params[key] = [];
        }
        params[key].push(value);
    }

    return params;
}


function removeBracketContent(str) {
    return str.replace(/\(.*?\)/, '').trim();
}

function make_filter_block_active() {
    // Get the current URL
    /*var currentUrl = window.location.href;

    // Get the query parameters from the current URL
    var queryParams = getQueryParams(currentUrl);

    // Check if the specific query parameter and value exist
    var paramName = 'filter.p.product_type';*/

    jQuery('.t4s-facet .t4s-filter__values li').each(function() {
        if( jQuery(this).hasClass('is--selected') ){
           jQuery(this).parents('.t4s-facet').addClass('active');
        }
        /*var paramValue = $(this).find('a').text().trim();
        var currentParamValue = queryParams[paramName];
            paramValue = removeBracketContent(paramValue);
            console.log(paramValue);
        if (currentParamValue && currentParamValue === paramValue) {
           jQuery(this).parents('.t4s-facet').addClass('active');
        }*/
    }); 
} 

  function hide_out_of_stock_when_filter_active() {
      var currentUrl = window.location.href;
  
      // Get the query parameters from the current URL
      var queryParams = getQueryParams(currentUrl);
      //console.log("Query Params: ", queryParams);
  
      // Check if the specific query parameter and value exist
      var paramName = 'filter.v.option.size';
      var paramValues = queryParams[paramName];
      //console.log("Parameter Values: ", paramValues);

      if (paramValues) {
          $('.t4s-product').each(function() {
              var product = $(this); // Cache the current product element
              var isSoldOut = false;
  
              product.find('.t4s-product-sizes .t4s-truncate span').each(function() {
                  var size = $(this).text().trim(); // Ensure text is trimmed
                  //console.log("Checking size: ", size);
  
                  if ($.inArray(size, paramValues) !== -1) { // Check if size is in paramValues
                      console.log("Size matches filter: ", size);
  
                      if ($(this).hasClass('t4s-product-sizes--sold-out')) {
                          //console.log("Size is sold out: ", size);
                          isSoldOut = true;
                          return false; // Exit the loop once a sold-out variant is found 
                      }
                  }
              });
  
              if (isSoldOut) {
                  //console.log("Hiding product: ", product); // Debugging line
                  product.addClass('isSoldout');
                  product.hide(); // Hide the product if a sold-out variant is found
              }
          });
      }
    }

// Display an error message if a product option is not selected when adding a product to cart
jQuery(document).ready(function ($) {  
  $(document).on('click', '.template-product .t4s-product__info-wrapper .t4s-form__product .t4s-product-form__submit', function (e) {   
    const productCartForm = $(this).closest('form');
    let hasError = false;
    let variantErrorMessages = [];
    
    // Check each variant swatch
    productCartForm.find('.t4s-swatch').each(function () {      
      let selected = $(this).find('.t4s-swatch__item.is--selected');
      let label = $(this).find('.t4s-swatch__title').data('option-name');
      if (!selected.length) {
        hasError = true;
        variantErrorMessages.push(`Please select your ${label.toLowerCase()}`);       
      } 
    });

    if (hasError) {
      e.preventDefault(); 
      productCartForm.find('#variant-error').html(variantErrorMessages.join('<br>')).fadeIn();
    } else {
      productCartForm.find('#variant-error').fadeOut();
    }
  });
});

//Display product title above the product image on mobile devices
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 767) {
    var title = document.querySelector('.template-product .t4s-product__title');
    var gallery = document.querySelector('.template-product .icartShopifyCartContent');
    var ratingWidget = document.querySelector('.gw-rv-star-rating-widget-placeholder[gw-for-mb="gw-star-for-mobile"]');
    if (title && gallery) {
      gallery.insertBefore(title, gallery.firstChild);
      title.style.setProperty('margin', '2.5rem 1rem 2rem 1rem', 'important');
      ratingWidget.style.setProperty('padding', '0px 0 0 0', 'important');
    }   
    
  }
});